import {
  OdReviewErrorType,
  OdReviewIssueStatus,
} from "../../../services/odReview/odReview.types";

export const OD_REVIEW_ERROR_TYPE_LABELS: Record<OdReviewErrorType, string> = {
  RECURSO_INCORRECTO: "Recurso incorrecto",
  RECURSO_FALTANTE: "Recurso faltante",
  REFERENCIA_NO_VERIFICABLE: "Referencia no verificable",
  FOTO_INCORRECTA: "Foto incorrecta",
  CONTENIDO_INCORRECTO: "Contenido incorrecto",
  ERROR_DE_TEXTO: "Error de texto",
};

export interface IssueStatusTagStyle {
  color: string;
  label: string;
}

export const OD_REVIEW_ISSUE_STATUS_TAGS: Record<
  OdReviewIssueStatus,
  IssueStatusTagStyle
> = {
  PENDING: { color: "default", label: "Pendiente" },
  ACCEPTED: { color: "green", label: "Aceptado" },
  REJECTED: { color: "red", label: "Rechazado" },
  PENDING_MANUAL: { color: "orange", label: "Pendiente manual" },
  RESOLVED_MANUAL: { color: "blue", label: "Resuelto a mano" },
};
